export default __webpack_public_path__ + "static/media/games-img.37f40c4b.webp";